import React from "react";
import { Button, Tooltip } from "@mui/material";
import { useParams } from "react-router-dom";
import { ESRFieldProps, ESRState } from "../../types/data";
import { useRemoteField } from "../../hooks/useRemoteField";
import { Replay } from "@mui/icons-material";
import { useSelector } from "react-redux";

export const ESRButtonField = (props: ESRFieldProps) => {
	const { question_id, field_options, locked, staticValue, hint_value } = props;
	const [value, setValue] = (staticValue != null) ?
		[staticValue, ()=>{}] : useRemoteField(question_id);
	const hasPendingResponses = useSelector((state: ESRState) =>
		Object.values(state.responses).some((r) => r.pending === true)
	);
	return (
		<Tooltip title={hasPendingResponses ? "Save or discard changes first" : ""}>
			<span>
				<Button
					disabled={locked > 0 || hasPendingResponses}
					id={question_id}
					variant="contained"
					onClick={(e) => setValue(value != "True" ? "True" : "False")}
					startIcon={
						hint_value === "e.g. workflow" &&
						<Replay sx={{ color: "white" }} />
					}
				>
					{value != "True" || field_options.length == 1
						? field_options[0]
						: field_options[1]}
				</Button>
			</span>
		</Tooltip>
	);
};